"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Breadcrumbs;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
/* eslint-disable max-len */

const BreadcrumbsSection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "BreadcrumbsSection",
  class: "pl-bp7k8h1"
});
const BreadcrumbList = /*#__PURE__*/(0, _react2.styled)("ol")({
  name: "BreadcrumbList",
  class: "pl-biy8r6v"
});
const IconChevronRight = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconChevronRight",
  class: "pl-i1pmykp2"
});
const Crumb = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "Crumb",
  class: "pl-c64cpaq"
});

// eslint-disable-next-line max-params
function createCrumb(key, title, href, includeChevron, keywordsMap) {
  if (title?.length === 0) {
    return;
  }
  title = decodeURI(title);
  title = title.replaceAll(/-|%20/g, ' ').split(' ').map(word => {
    const keyword = word.toLowerCase();
    if (keywordsMap[keyword]) {
      return keywordsMap[keyword];
    }
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ');
  const crumb = /*#__PURE__*/_react.default.createElement(Crumb, {
    key: key,
    "data-cy": "breadcrumb-item",
    itemProp: "itemListElement",
    itemScope: true,
    itemType: "https://schema.org/ListItem"
  }, includeChevron ? /*#__PURE__*/_react.default.createElement("a", {
    itemProp: "item",
    href: href
  }, /*#__PURE__*/_react.default.createElement("span", {
    itemProp: "name"
  }, title)) : /*#__PURE__*/_react.default.createElement("span", {
    itemProp: "name"
  }, title), /*#__PURE__*/_react.default.createElement("meta", {
    itemProp: "position",
    content: key
  }), includeChevron && /*#__PURE__*/_react.default.createElement(IconChevronRight, {
    "data-cy": "icon"
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-right"
  })));
  return crumb;
}

// Clean up duplicated paths
function cleanDuplicatePath(url) {
  const [base, ...pathSegments] = url.split('/');
  const cleanedSegments = Array.from(new Set(pathSegments));
  return [base, ...cleanedSegments].join('/');
}

/**
 * Breadcrumbs component.
 * @module Breadcrumbs
 *
 * @param {Object} props React props
 * @param {string} props.id id string
 * @param {string} props.currentUrl base url string e.g. https://www.godaddy.com
 * @param {string} props.path path string e.g. /en-us/preview/godaddy/sales/home
 * @param {string} props.logoAriaLabel ariaLabel string
 * @param {string} props.keywords ariaLabel string
 * @param {string} props.partial theme partial to apply
 * @returns {React.ReactElement} Footer Legal layout
 * @public
 */

// eslint-disable-next-line max-statements
function Breadcrumbs({
  id,
  currentUrl,
  path,
  logoAriaLabel,
  keywords,
  partial = 'dark1'
}) {
  let baseUrl = currentUrl;
  let pages = path.split('/')?.filter(page => page !== '');
  const crumbs = [];
  const keywordsMap = {};

  // keywords transformation
  const keywordsList = keywords ? keywords.split(',') : [];
  if (keywordsList.length > 0) {
    keywordsList.forEach(keyword => {
      keywordsMap[keyword.toLowerCase()] = keyword;
    });
  }

  // include market code in base url if it exists
  if (pages.length > 0 && (pages[0].match(/^[a-z]{2}-[a-z]{2}$/) || pages[0].match(/^[a-z]{2}$/))) {
    baseUrl = `${currentUrl}/${pages[0]}`;
    pages.shift();
  }
  // example pages should only show the leaf page
  if (pages.includes('preview') && pages.includes('examples')) {
    baseUrl = `${baseUrl.replace('www', 'origin-swp')}/preview/examples/home`;
    pages = pages.slice(pages.length - 1);
  }
  const basePath = ['preview', 'godaddy', 'sales'];
  pages = pages && pages.filter(page => {
    if (basePath.includes(page)) {
      baseUrl = `${baseUrl}/${page}`;
      return false;
    }
    return true;
  });
  baseUrl = cleanDuplicatePath(baseUrl);
  const baseCrumb = /*#__PURE__*/_react.default.createElement(Crumb, {
    key: 0,
    "data-cy": "breadcrumb-item",
    itemProp: "itemListElement",
    itemScope: true,
    itemType: "https://schema.org/ListItem"
  }, /*#__PURE__*/_react.default.createElement("meta", {
    itemProp: "name",
    content: logoAriaLabel
  }), /*#__PURE__*/_react.default.createElement("a", {
    itemProp: "item",
    href: baseUrl
  }, /*#__PURE__*/_react.default.createElement("svg", {
    "data-cy": "godaddy-icon",
    "aria-label": logoAriaLabel,
    width: "27",
    height: "24",
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.2898 1.09579C20.4839 -0.650961 16.7898 -0.238551 13.4952 1.82921C10.2109 -0.237408 6.51458 -0.650961 3.71203 1.09579C-0.721244 3.86157 -1.26024 10.9856 2.5093 17.0062C5.28782 21.4467 9.63298 24.0468 13.5009 23.9989C17.3689 24.0468 21.7141 21.4467 24.4926 17.0062C28.2575 10.9856 27.7231 3.86157 23.2898 1.09579ZM4.54742 15.7358C3.76994 14.5054 3.18348 13.1647 2.80798 11.7591C2.4741 10.5393 2.34647 9.2725 2.43034 8.01081C2.59856 5.78653 3.50604 4.05349 4.98457 3.13042C6.46309 2.20735 8.41766 2.15366 10.4993 2.97734C10.8157 3.10437 11.1254 3.24736 11.4273 3.40574C10.2703 4.458 9.26448 5.66474 8.43826 6.99177C6.14953 10.6475 5.45147 14.7168 6.25023 17.9589C5.61391 17.2729 5.04378 16.5286 4.54742 15.7358ZM24.195 11.7591C23.819 13.1645 23.2326 14.5052 22.4556 15.7358C21.9594 16.5302 21.3893 17.276 20.7528 17.9635C21.4669 15.0561 20.9817 11.4952 19.2308 8.15475C19.2031 8.09951 19.164 8.05072 19.1161 8.01157C19.0682 7.97241 19.0126 7.94376 18.9529 7.92748C18.8932 7.91121 18.8308 7.90767 18.7696 7.91711C18.7084 7.92654 18.6499 7.94874 18.5979 7.98225L13.1393 11.3878C13.0896 11.4187 13.0464 11.4591 13.0123 11.5067C12.9783 11.5543 12.954 11.6081 12.9408 11.6651C12.9276 11.7221 12.9258 11.7811 12.9355 11.8388C12.9452 11.8965 12.9663 11.9517 12.9974 12.0012L13.7985 13.2796C13.8294 13.3293 13.8699 13.3723 13.9176 13.4064C13.9653 13.4404 14.0192 13.4647 14.0763 13.4778C14.1334 13.491 14.1925 13.4928 14.2503 13.4831C14.3081 13.4734 14.3634 13.4524 14.413 13.4213L17.9514 11.2153C18.0658 11.558 18.1803 11.895 18.2661 12.2434C18.5999 13.4632 18.7275 14.73 18.6437 15.9917C18.4755 18.2171 17.568 19.9501 16.0895 20.8732C15.3269 21.3387 14.4531 21.5912 13.5593 21.6044H13.4449C12.5511 21.5915 11.6772 21.3389 10.9147 20.8732C9.435 19.9501 8.52752 18.2171 8.3593 15.9917C8.27611 14.73 8.40373 13.4633 8.73694 12.2434C9.50427 9.42175 11.0896 6.88927 13.2938 4.96399C14.2445 4.1306 15.3273 3.46077 16.498 2.98191C18.5739 2.15823 20.5319 2.21192 22.0116 3.13499C23.4913 4.05806 24.3976 5.7911 24.5658 8.01538C24.6509 9.27516 24.5256 10.5403 24.195 11.7591ZM21.0721 22.9193V22.7605C21.0718 22.755 21.0727 22.7496 21.0747 22.7444C21.0767 22.7393 21.0797 22.7347 21.0835 22.7308C21.0872 22.7269 21.0916 22.7239 21.0966 22.7219C21.1015 22.7199 21.1068 22.7191 21.1121 22.7194H22.126C22.1313 22.7191 22.1367 22.7199 22.1416 22.7219C22.1465 22.7239 22.151 22.7269 22.1546 22.7308C22.1585 22.7347 22.1615 22.7393 22.1634 22.7444C22.1654 22.7496 22.1663 22.755 22.1661 22.7605V22.9193C22.1664 22.9248 22.1655 22.9302 22.1635 22.9354C22.1616 22.9405 22.1585 22.9451 22.1546 22.949C22.151 22.9528 22.1465 22.9559 22.1416 22.9578C22.1367 22.9598 22.1313 22.9607 22.126 22.9604H21.7553V23.9577C21.7555 23.9633 21.7545 23.9689 21.7523 23.974C21.7501 23.9791 21.7468 23.9837 21.7427 23.9874C21.739 23.9914 21.7346 23.9945 21.7297 23.9967C21.7248 23.9989 21.7194 24 21.7141 24H21.5229C21.5121 23.9997 21.5018 23.9952 21.4943 23.9874C21.4871 23.9792 21.483 23.9687 21.4829 23.9577V22.9604H21.1121C21.1068 22.9607 21.1015 22.9598 21.0966 22.9578C21.0916 22.9559 21.0872 22.9528 21.0835 22.949C21.0796 22.9451 21.0766 22.9405 21.0746 22.9354C21.0726 22.9302 21.0718 22.9248 21.0721 22.9193ZM22.8435 22.7559L23.1262 23.3957L23.41 22.7559C23.4144 22.7445 23.4224 22.7348 23.4329 22.7285C23.4438 22.7216 23.4566 22.7184 23.4695 22.7194H23.7728C23.7781 22.7192 23.7833 22.7201 23.7883 22.7221C23.7932 22.724 23.7977 22.727 23.8014 22.7307C23.8052 22.7345 23.8081 22.7389 23.8101 22.7439C23.8121 22.7488 23.813 22.754 23.8128 22.7593V23.96C23.813 23.9705 23.8094 23.9807 23.8025 23.9886C23.799 23.9922 23.7947 23.9951 23.79 23.9971C23.7852 23.9991 23.7802 24.0001 23.7751 24H23.5931C23.5824 24 23.5722 23.9959 23.5645 23.9886C23.5572 23.9808 23.5531 23.9706 23.5531 23.96V23.0529L23.2567 23.7121C23.2521 23.7244 23.2442 23.7351 23.2338 23.743C23.2224 23.7498 23.2092 23.7529 23.196 23.7521H23.0495C23.0367 23.7528 23.0239 23.7496 23.0129 23.743C23.0025 23.7351 22.9946 23.7244 22.99 23.7121L22.6936 23.0529V23.96C22.6938 23.9653 22.6929 23.9706 22.691 23.9755C22.689 23.9804 22.686 23.9849 22.6822 23.9886C22.6748 23.9958 22.665 23.9999 22.6547 24H22.4716C22.4665 24.0001 22.4614 23.9991 22.4567 23.9971C22.452 23.9951 22.4477 23.9922 22.4442 23.9886C22.4369 23.9808 22.4328 23.9706 22.4327 23.96V22.7593C22.4327 22.754 22.4337 22.7486 22.4359 22.7437C22.4381 22.7388 22.4413 22.7344 22.4453 22.7308C22.4488 22.727 22.453 22.724 22.4578 22.7221C22.4625 22.7201 22.4676 22.7192 22.4728 22.7194H22.7852C22.798 22.7186 22.8108 22.7218 22.8218 22.7285C22.8319 22.735 22.8396 22.7446 22.8435 22.7559Z",
    fill: "#AFAFAF"
  }))), /*#__PURE__*/_react.default.createElement("meta", {
    itemProp: "position",
    content: 0
  }), /*#__PURE__*/_react.default.createElement(IconChevronRight, {
    "data-cy": "icon"
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-right"
  })));
  crumbs.push(baseCrumb);
  pages.forEach((page, i) => {
    const href = `${baseUrl}/${pages.slice(0, i + 1).join('/')}`;
    const includeChevron = i < pages.length - 1;
    const crumb = createCrumb(i + 1, page, href, includeChevron, keywordsMap);
    crumbs.push(crumb);
  });
  return pages.length > 0 && /*#__PURE__*/_react.default.createElement(BreadcrumbsSection, {
    id: `id-${id}`,
    dataCy: "breadcrumbs-section",
    partial: partial
  }, /*#__PURE__*/_react.default.createElement(BreadcrumbList, {
    itemScope: true,
    itemType: "https://schema.org/BreadcrumbList"
  }, crumbs));
}
Breadcrumbs.propTypes = {
  id: _propTypes.default.string,
  currentUrl: _propTypes.default.string,
  path: _propTypes.default.string,
  logoAriaLabel: _propTypes.default.string,
  keywords: _propTypes.default.string,
  partial: _propTypes.default.string
};